import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDatabase, FiHash, FiLayers, FiMenu } = FiIcons;

const BottomNavigation = () => {
  const location = useLocation();

  const navItems = [
    { id: 'library', path: '/', icon: FiDatabase, label: 'Library' },
    { id: 'variables', path: '/variables', icon: FiHash, label: 'Variables' },
    { id: 'compose', path: '/compose', icon: FiLayers, label: 'Compose' },
    { id: 'menu', path: '#menu', icon: FiMenu, label: 'Menu' },
  ];

  const handleMenuClick = (e) => {
    e.preventDefault();
    const event = new CustomEvent('openMobileMenu');
    window.dispatchEvent(event);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-black pb-safe">
      <div className="h-[72px] flex items-center justify-around px-2">
        {navItems.map((item) => {
          const isActive = item.id === 'menu'
            ? false
            : location.pathname === item.path;

          const handleClick = item.id === 'menu' ? handleMenuClick : undefined;

          return (
            <Link
              key={item.id}
              to={item.path}
              onClick={handleClick}
              className={`flex flex-col items-center justify-center min-w-[72px] min-h-[72px] flex-1 transition-all ${
                isActive
                  ? 'text-black'
                  : 'text-gray-600'
              }`}
            >
              <div
                className={`p-2 rounded-lg border-2 transition-all ${
                  isActive
                    ? 'bg-neo-blue border-black shadow-neo translate-y-[-2px]'
                    : 'border-transparent hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={item.icon} size={24} className={isActive ? 'text-black' : ''} />
              </div>
              <span className="text-xs font-bold mt-1 uppercase">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
